export default __webpack_public_path__ + "static/media/registered.2e8cd477.svg";